/*************
 * addToCartAjax
 * A utility to use in quick view modal (or elsewhere) to add a single variant id and qty
 * to the shopping cart via an AJAX call. There is a public 'on' API to subscribe to either
 * 'error' or 'success'
 * custom.addToCartAjax.on('success',function(e){console.log(e)});
 *
 * Usage:
 * <form action="/cart/add" method="post" class="js-add-to-cart">
 *  <select name="id">
 *      <option value="" disabled selected>Select a Size</option>
 *      <option value="[[objectID]]">[[variant_title]]</option>
 *  </select>
 *  <input type="number" name="quantity" min="1" value="1" />
 *  <button type="submit">Add to cart</button>
 * </form>
 */

custom.loadMoreArticle = (() => {
  const loadMoreArticleClass = 'js-load-more-article'; // Form Class
  let actions = {
    // PubSub callbacks
    success: [],
    error: [],
  };

  // Subscribe to events
  function on(evt = null, callback = null) {
    if (!evt || !callback || typeof callback !== 'function') return;
    actions[evt] = actions[evt] || [];
    actions[evt].push(callback);
  }

  // Trigger events
  function trigger(evt = null, payload = {}) {
    if (!evt) return;
    actions[evt].forEach((fn) => fn(payload));
  }

  // Error Handler
  function errorHandler({ responseJSON }) {
    trigger('error', responseJSON);
    console.log(responseJSON);
  }

  // Success Handler
  function successHandler(data) {
    injectsNewResult(data);
    custom.inViewport.init();
    trigger('success', data);
  }

  function injectsNewResult(data) {
    const $container = $('#results');
    const newResults = $(data).find('#results').html();

    $('body').find(`.${loadMoreArticleClass}`).remove();
    $container.append(newResults);
  }

  // Add to Cart Handler
  function loadMoreArticleHandler(e = null) {
    if (!e) return;
    e.preventDefault();
    const url = e.currentTarget.getAttribute('href');

    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      success: successHandler,
      error: errorHandler,
    });
  }

  // Bind, init and delegate
  $('body').on('click', `.${loadMoreArticleClass}`, loadMoreArticleHandler);

  return {
    on,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/load-more-article.js